"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/Filter.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Filter = function Filter(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "line-icon",
    viewBox: "0 0 259.49 256.49"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "filter"), _react2.default.createElement("path", {
    className: "filter",
    d: "M215.07 54.59c0-6.93-9.54-12.18-29.16-16-17.13-3.38-29.86-5.24-54-5.24s-36.86 1.86-54 5.24c-19.62 3.87-29.16 9.12-29.16 16a7.28 7.28 0 0 0 .57 2.8l65.9 76.07v96.93l39.17-39.22v-57.79l60.15-76.12a7.27 7.27 0 0 0 .53-2.67zm-7.28 0c-.08.24-2.15 4.85-24.13 9.07-16.58 3.18-28.51 4.93-51.74 4.93s-35.15-1.75-51.74-4.93c-22.46-4.31-24.13-9-24.13-9.06s1.68-4.77 24.14-9.08c16.58-3.18 28.5-4.93 51.73-4.93s35.15 1.75 51.73 4.93c21.99 4.22 24.05 8.84 24.14 9.07zM146.4 187.87l-23.17 23.2v-80.13L66 67.76q5.16 1.55 11.89 2.88c17.13 3.38 29.85 5.24 54 5.24s36.86-1.86 54-5.24a122.78 122.78 0 0 0 12.86-3.17L146.4 131v56.84z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }));
};
exports.default = Filter;